// extracted by mini-css-extract-plugin
export default {"errorMessage":"styles_errorMessage__nZJvT","inputLabel":"styles_inputLabel__F8hfy"};